/**
 * TODO this won't work correctly unless the following conditions are satisfied:
 * 1. The HTML chunk received needs to be pretty tall (assuming it's not the final chunk)
 * 2. The browser isn't being refreshed at the bottom of the page.
 *
 * If the above conditions are being satisfied then it will work fine.
 */


(function () {
    'use strict';

    var postsLoadArea = document.querySelector('.js-postsLoadArea');            // the div into newly loaded posts are injected
    var postsLoadMarker = document.querySelector('.js-loadMorePosts-marker');   // an invisible element that gets observed, this triggers new posts to be loaded

    var request = new XMLHttpRequest();

    var endpointURLPrefix = '/wp-json/sfl/v1/load-more-posts?';

    var URL = false;
    var receivedData = false;

    if (typeof filterCurrentPage !== 'undefined') {
        var requestObject = {
            page: 2,
            // taxonomy: filterCurrentPage.taxonomy,
            // term: filterCurrentPage.term,
            postType: filterCurrentPage.postType,
        }
    }

    if (postsLoadArea && requestObject && requestObject.postType && postsLoadMarker) {
        init();
    }


    function init() {
        URL = endpointURLPrefix + objToURI(requestObject);
        observer();
    }


    /**
     * Set an IntersectionObserver to watch our marker to load more posts.
     */
    function observer() {
        const observerOptions = {
            rootMargin: '0px 0px 0px 0px',
            threshold: 0
        }

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (entry.intersectionRatio !== 0) {
                    if (!receivedData.pages || (requestObject.page <= receivedData.pages)) {
                        loadPosts_doAJAX(URL);
                    }
                }
            });
        }, observerOptions);

        observer.observe(postsLoadMarker);
    }


    function loadPosts_doAJAX(URL) {
        if (request.readyState !== 4) {
            request.abort();
        }

        request.onreadystatechange = function () {

            if (request.readyState === 4) {

                if (request.status === 200) {
                    receivedData = JSON.parse(request.response);
                    handleDataLoadedEvent(receivedData);

                } else {
                    console.log('failed! ' + request.status);
                }

            }

        }

        request.open('GET', URL);
        request.send();
    }


    function handleDataLoadedEvent(receivedData) {

        /* create a new elm, inject received HTML string in a way that converts
        it into a DOM element, add to page, init any new videos */

        var elmNew = document.createElement('div');
        elmNew.innerHTML = receivedData.html;

        const elmsNew = elmNew.querySelectorAll('.news__card');

        elmsNew.forEach(function(elm) {
            postsLoadArea.insertAdjacentElement('beforebegin', elm);
        });

        lazyLoadInstance.update();
        requestObject.page++;
        URL = endpointURLPrefix + objToURI(requestObject);
    }


    /**
     * URL BUILDING
     */

    function objToURI(obj) {
        var str = [];

        Object.keys(obj).forEach(function (key) {
            if (obj.hasOwnProperty(key)) {
                if (obj[key]) {
                    var value = obj[key];
                    if (typeof value === 'string') {
                        value = value.toLowerCase();
                    }
                    str.push(encodeURIComponent(key.toLowerCase()) + "=" + encodeURIComponent(value));
                }
            }
        });

        return str.join("&");
    }

})();